<template>
    <div class="flex-column-footer">
        <slot></slot>
    </div>
</template>
<script>
export default {
}
</script>
<style scoped lang="scss">
.flex-column-footer {
    flex: none;
}
</style>